import React from 'react';

interface IFormProps {
  content: React.ReactNode;
  maxWidth?: number;
}

export const Form = ({ content, maxWidth }: IFormProps) => {
  return (
    <div
      style={{ maxWidth: maxWidth ? maxWidth : 'auto' }}
      className="bg-white px-[16px] py-[24px] sm:px-[24px] sm:py-[40px] flex flex-col border-[1px] border-[#E0E1E2] rounded-[16px] sm:rounded-[24px] w-full"
    >
      {content}
    </div>
  );
};
